import {toList, toString} from "../helpers/helpers";

export declare type UrlParams = {
  [key: string]: any;
};

export enum UrlParamsInclusionMode {
  Truthy = 0,
  NotUndefined = 1,
  NotNullOrUndefined = 2,
  All = 4,
}

const inclusionMethods: {[key: number]: (input?) => boolean} = {
  [UrlParamsInclusionMode.Truthy]: obj => !!obj,
  [UrlParamsInclusionMode.NotUndefined]: obj => obj !== undefined,
  [UrlParamsInclusionMode.NotNullOrUndefined]: obj => obj !== null && obj !== undefined,
  [UrlParamsInclusionMode.All]: () => true,
};

export function paramsToHttpParamsLike(params: UrlParams | any): {[key: string]: string | string[]} {
  if (!params) return {};

  const result = {};

  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      result[key] = toList(toString, value);
    } else {
      result[key] = toString(value);
    }
  }

  return result;
}

export function paramsToQueryString(
  params: UrlParams | any,
  inclusionMode: UrlParamsInclusionMode = UrlParamsInclusionMode.Truthy,
): URLSearchParams {
  const inclusionMethod = inclusionMethods[inclusionMode];
  return Object.keys(params)
    .map((key) => {
      let value = params[key];

      if (!inclusionMethod(value)) return undefined;
      if ((typeof value) !== "string") value = `${value}`;

      return {key, value};
    })
    .filter(obj => obj !== undefined)
    .reduce(
      (urlSearchParams: URLSearchParams, {key, value}) => {
        urlSearchParams.set(key, value);
        return urlSearchParams;
      },
      new URLSearchParams(),
    );
}

export function extractPathFromUrlString(url: string): string {
  return new URL(url, "http://www.hp.com").pathname;
}
